module.exports = __webpack_public_path__ + "img/img_012@2x.dc6c4414.png";